import {v3} from "oc-threejs/short3";
import GriffO3 from "../object3d/Griff";
import Maths3 from "oc-threejs/Maths3";

export default class Griff {

    static defaultQuaternion = Maths3.quaternion.x90;
    // persistent (UserLayer) ------------------------------------------

    // transient (CompiledLayer) ---------------------------------------
    parent: Object;
    object3d: ?THREE.Object3D;
    position = new THREE.Vector3();
    quaternion = new THREE.Quaternion();
    parent3d: ?THREE.Object3D;
    griffArtikelnummer: ?string;

    constructor(parent) {
        this.parent = parent;
    }

    get schrank() {
        return this.parent.schrank;
    }

    get arrangement() {
        return this.schrank.arrangement;
    }

    compile() {
        APP.model.lazyCreateObject3d(this, () => {
            const o3 = new GriffO3(this);
            this.parent.child3dContainer.add(o3);
            return o3;
        });
    }

    get artikelnummer() {
        return this.griffArtikelnummer!=null ? this.griffArtikelnummer : this.arrangement.griffArtikelnummer;
    }

    getBoundingBoxLocal() {
        const box = APP.getBoundingBox(this.artikelnummer);
        box.setFromCenterAndSize(v3(), box.getSize());
        box.applyQuaternion(this.quaternion.clone().multiply(Griff.defaultQuaternion));
        return box;
    }

    iterate(iterator) {
        iterator(this);
    }

}
